import di from "@frameworks/web/components/features/LoginFlow/di/servicelocator";
import ErrorExclamation from "@frameworks/web/components/generic/errorExclamation";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import OtpPage from "./OtpPage";
import { loginHelp } from "../LogintextConfig";
import { otpValidityTime } from "../constant";
const GuestRegValidateOTP = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const locationState = location.state;
    const [timer, setTimer] = useState(true);
    const [resendOTPTimer, setResendOTPTimer] = React.useState(true);
    const [apiCall, setAPICall] = useState(false);
    const [loginButtonDisable, setLoginDisable] = React.useState(false);
    const [errResendOtp, setErrResendOtp] = useState(false);
    const [otpValidTime, setOtpValidTime] = React.useState(otpValidityTime);
    //validate guest OTP reducer
    const { data: guestRegister, errorData: guestRegisterError, loader: guestRegisterLoader, } = useSelector((state) => state.LoginFlow.guestRegister);
    const validateOTP = (otp) => {
        let payload = {
            mob: props.mob ? props.mob : locationState === null || locationState === void 0 ? void 0 : locationState.mob,
            countryCode: "91",
            otp: String(otp),
            appData: { build: "web-pc" },
        };
        di.login.guestRegValidateOTP(payload);
        setAPICall(true);
        setTimer(false);
    };
    const getInvalidOtpSection = () => {
        if (!guestRegisterLoader && guestRegisterError.isOpen) {
            switch (guestRegisterError.error.getErrCd()) {
                case "0":
                    return (React.createElement(ErrorExclamation, { parentClass: "text-nowrap", errorMessage: loginHelp.invalidOTP, avoidBackground: true }));
                default:
                    return (React.createElement(ErrorExclamation, { errorMessage: guestRegisterError.error.getErrorMessageOrErrMsg(), avoidBackground: true }));
            }
        }
    };
    const resendOTP = () => {
        let payload = {
            mobileNo: props.mob,
            build: "web-pc",
            countryCode: "91",
            req: "resend",
        };
        di.login
            .guestRegister(payload)
            .then(() => {
            setResendOTPTimer(true);
            setTimer(true);
            setOtpValidTime(otpValidityTime);
        })
            .catch((err) => {
            setErrResendOtp(true);
        });
    };
    const generateOtpError = () => {
        if (errResendOtp)
            return React.createElement(ErrorExclamation, { errorMessage: "Something went wrong!" });
    };
    React.useEffect(() => {
        if (!guestRegisterError.isOpen && !guestRegisterLoader && apiCall) {
            if (guestRegister.OTPValidated) {
                (props === null || props === void 0 ? void 0 : props.navigateTo)
                    ? props === null || props === void 0 ? void 0 : props.setScreenState(props === null || props === void 0 ? void 0 : props.navigateTo)
                    : navigate("/guest-set-mpin");
            }
        }
        else if (guestRegisterError.isOpen && !guestRegisterLoader) {
            setLoginDisable(true);
        }
    }, [guestRegisterLoader, guestRegisterError, guestRegister, apiCall]);
    return (React.createElement(React.Fragment, null,
        React.createElement(OtpPage, { pageheading: (props === null || props === void 0 ? void 0 : props.pageHeading) || "Register", otpText: "your Mobile Number", submit: validateOTP, btnText: "Submit", showTimer: timer, setTimer: setTimer, errorState: (otp) => {
                if (otp.toString().length != 4)
                    return false && !loginButtonDisable;
                return true && !loginButtonDisable;
            }, resendOTPTimer: resendOTPTimer, setResendOTPTimer: setResendOTPTimer, customResendOTP: resendOTP, otpErrorBlocked: loginButtonDisable && getInvalidOtpSection(), timerValues: otpValidTime, errorAboveNext: generateOtpError(), noTimeOutIcon: !timer || (!guestRegisterLoader && guestRegisterError.isOpen), resetErrorState: () => {
                setErrResendOtp(false);
                if (loginButtonDisable) {
                    setLoginDisable(false);
                }
            } }),
        resendOTPTimer && (React.createElement("div", { className: "d-flex justify-content-center DMSanN_14_400 text-success pb-2" }, "OTP successfully sent."))));
};
export default GuestRegValidateOTP;
